import { gql } from '@apollo/client';

export const GET_SESSION_USER_INFO = gql`
  query GetSessionUserInfo {
    getSessionUserInfo {
      ... on GetUserSession {
        message
        version
        user {
          id
          account_id
          firstName
          lastName
          email
          avatarUrl
          locale
          timeZone
          role
          phone
          isWelcomeScreenClosed
          isEmailConfirmed
          analyticsConsent
          analyticsConsentAt
          analyticsConsentVersion
          settings {
            dashboardSettings {
              showTimer
              showClock
              showDate
              showSeconds
              upcomingJobsWindow
              dashboardMaxListLength
              dashboardShowOnlyNew
            }
          }
        }
        linkToken
      }
      ... on Error {
        message
      }
    }
  }
`;
